module.exports = __webpack_public_path__ + "img/tab.828886e7.jpg";